export const Salary_experience_year = function(lastNum = 0) {
  let save_experence_year = [];
  let maxExperience = 50;
  while (maxExperience >= lastNum) {
    save_experence_year.push({
      label: maxExperience + ' Year',
      value: maxExperience
    });
    maxExperience--;
  }
  save_experence_year.reverse();
  return save_experence_year;
};
export const Salary_experience_month = function() {
  let save_experence_month = [];
  let maxMonrth = 12;
  while (maxMonrth >= 0) {
    save_experence_month.push({
      label: maxMonrth + ' Month',
      value: maxMonrth
    });
    maxMonrth--;
  }
  save_experence_month.reverse();
  return save_experence_month;
};
